import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { parseISO, format } from 'date-fns';
import { useApi } from "../hooks/useApi";
import { Pagination } from "../components/ui/Pagination";
import React from 'react';
export default function DBLogs() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const initialized = useRef(false);
  const { apiCall } = useApi();
  const [logs, setLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const limit = 20; // per page
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetchPage(currentPage);
    }
  }, []);
  const fetchPage = async (page) => {


    setLoading(true);
    try {
      const queue = await apiCall(`fetch_db_logs`, { params: { page: page, limit: limit } });
      const logsJson = await queue.json();
      setLogs(logsJson.items || []);
      setTotalPages(logsJson.totalPages);
      setTotalRows(logsJson.totalRows); // from backend
      setLoading(false);
    }
    catch (error) {
      setError("Error loading queue.");
    }


  };
  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    fetchPage(page);
  };

  const formatText = (str) => {
    return str
      .replace(/_/g, ' ') // Replace all underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of every word
  };


  if (error) return <p>Error: {error}</p>;

  return (

    <div className="p-6">
      {/* Loading overlay */}
      <div className="flex justify-between items-center mb-4">

        <h1 className="text-2xl font-bold">Log List</h1>

      </div>
      <div className="flex justify-between items-end">

        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2 w-100">User</th>
              <th className="border p-2">Request</th>
              <th className="border p-2">Params</th>
              <th className="border p-2">Time</th>
            </tr>
          </thead>
          <tbody>

            {logs.map((log) => (
              <tr className="border" key={log.id}>
                <td className="border p-2">
                  {log.user_email}
                </td>
                <td className="border p-2" >
                  {formatText(log.command)}
                </td>
                <td className="border p-2" >
                  <>

                    {log.params && (
                      <>


                        <dl style={{ display: 'grid', gridTemplateColumns: 'max-content auto', gap: '8px 16px' }}>
                          {Object.entries(JSON.parse(log.params)).map(([key, value]) => (
                            <React.Fragment key={key}>
                              <dt style={{ fontWeight: 'bold', color: '#555' }}>{key}:</dt>
                              <dd style={{ margin: 0, color: '#222' }}>{value}</dd>
                            </React.Fragment>
                          ))}
                        </dl>
                      </>
                    )}
                  </>
                </td>
                <td className="border p-2" >
                  <div className="text-gray-700 mb-2 text-center">
                    {format((log.date), 'dd-MMM-yyyy HH:mm:ss')}
                  </div>

                </td>
              </tr>
            ))}
          </tbody>
        </table>


      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
        loading={loading}
      />

    </div>
  );
}
